// eslint-disable-next-line fsd/layer-imports
import { useProfile } from '@/entities/profile'

import { useAmplitude } from './useAmplitude'

export const useSessionTracking = () => {
  const { profile } = storeToRefs(useProfile())
  const { track, identify } = useAmplitude()

  const getDeviceInfo = () => {
    const userAgent = navigator.userAgent
    if (
      /Mobile|Android|iPhone|iPod|IEMobile|BlackBerry|Kindle|Silk-Accelerated|hpwOS|webOS|Opera Mobi|Opera Mini/.test(
        userAgent,
      )
    ) {
      return 'mobile'
    }
    if (/Tablet|iPad/.test(userAgent)) {
      return 'tablet'
    }
    return 'desktop'
  }

  const getLocationInfo = (userProfile: NonNullable<typeof profile.value>) => {
    if (!userProfile.office?.city?.country) {
      return 'unknown'
    }
    return `${userProfile.office.city.country.name}_${userProfile.office.city.name}_${userProfile.office.name}`
  }

  const startSession = () => {
    if (!profile.value) {
      return
    }

    identify(profile.value.id, {
      name: `${profile.value.firstName} ${profile.value.lastName}`,
      role: profile.value.role,
      department: profile.value.department?.name,
      office: profile.value.office?.name,
      city: profile.value.office?.city?.name,
      country: profile.value.office?.city?.country?.name,
    })

    track('session_start', {
      user_id: profile.value.id,
      timestamp: Date.now(),
      device: getDeviceInfo(),
      location: getLocationInfo(profile.value),
      department_type: profile.value.department?.name || 'unassigned',
      office_name: profile.value.office?.name || 'unknown',
      city_name: profile.value.office?.city?.name || 'unknown',
      country_name: profile.value.office?.city?.country?.name || 'unknown',
      user_role: profile.value.role,
    })
  }

  const startHeartbeat = () => {
    const heartbeatInterval = setInterval(
      () => {
        if (profile.value) {
          track('session_heartbeat', {
            user_id: profile.value.id,
            timestamp: Date.now(),
            session_duration_minutes: 5,
          })
        }
      },
      5 * 60 * 1000,
    )

    return () => clearInterval(heartbeatInterval)
  }

  const endSession = () => {
    if (profile.value) {
      track('session_end', {
        user_id: profile.value.id,
        timestamp: Date.now(),
      })
    }
  }

  return {
    startSession,
    startHeartbeat,
    endSession,
    getDeviceInfo,
    getLocationInfo,
  }
}
